<template>
  <!-- Single mode: mutually-exclusive, deselectable option buttons (0 or 1). -->
  <div v-if="single" class="flex flex-wrap gap-3">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      :data-objective="opt.value"
      @click="toggle(opt.value)"
      :class="[
        'border rounded-[9px] px-[15px] py-[10px] text-[14px] leading-[18px] text-left transition-colors',
        isSelected(opt.value)
          ? 'border-[#489B79] bg-[#489B79] text-white'
          : 'border-[#DADADA] bg-white text-gray-800 hover:border-[#489B79]'
      ]"
    >
      {{ opt.label }}
    </button>
  </div>

  <!-- Default mode: multi-select checkboxes (unchanged). -->
  <div v-else class="space-y-2">
    <label
      v-for="opt in options"
      :key="opt.value"
      :data-objective="opt.value"
      class="flex items-center gap-3 cursor-pointer text-[14px] leading-[26px] font-medium text-black"
      @click.prevent="toggle(opt.value)"
    >
      <span
        :class="[
          'h-5 w-5 rounded-[5px] border flex items-center justify-center shrink-0',
          isSelected(opt.value) ? 'bg-[#489B79] border-[#489B79]' : 'border-[#DADADA] bg-white'
        ]"
      >
        <svg v-if="isSelected(opt.value)" class="h-3.5 w-3.5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12.5l4 4L19 7" />
        </svg>
      </span>
      {{ opt.label }}
    </label>
  </div>
</template>

<script>
import { VIDEOCALL_OBJECTIVES } from "@/services/videocall";

export default {
  name: "ObjectiveSelect",
  props: {
    modelValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => VIDEOCALL_OBJECTIVES },
    // When true the objectives behave as mutually-exclusive, optional buttons
    // (pick one or the other, or none). The model stays an array of 0 or 1 value.
    single: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  methods: {
    isSelected(value) {
      return this.modelValue.includes(value);
    },
    toggle(value) {
      if (this.single) {
        // Re-clicking the selected option clears it; otherwise it replaces any
        // previous choice — never more than one selected.
        const next = this.isSelected(value) ? [] : [value];
        this.$emit("update:modelValue", next);
        return;
      }
      const next = this.isSelected(value)
        ? this.modelValue.filter((v) => v !== value)
        : [...this.modelValue, value];
      this.$emit("update:modelValue", next);
    },
  },
};
</script>
